import { create } from 'zustand';
import { tokenStorage, type StoredUser } from './tokenStorage';

interface AuthState {
  user: StoredUser | null;
  hasTokens: boolean;
  setSession: (access: string, refresh: string, user: StoredUser) => void;
  signOut: () => void;
  hydrate: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  hasTokens: false,
  setSession: (access, refresh, user) => {
    tokenStorage.setAll(access, refresh, user);
    set({ user, hasTokens: true });
  },
  signOut: () => {
    tokenStorage.clear();
    set({ user: null, hasTokens: false });
  },
  hydrate: () => {
    const access = tokenStorage.getAccess();
    const user = tokenStorage.getUser();
    if (access && user) {
      set({ user, hasTokens: true });
    }
  },
}));
